import { Injectable } from '@angular/core';
import { environment } from "../environments/environment";
import { Http, Response, ResponseContentType } from "@angular/http";
import { AuthHttp } from 'angular2-jwt';
import { Observable } from "rxjs/Observable"
import "rxjs/add/operator/map";

@Injectable()
export class MonthlyReportApiService {

  constructor(
    private monthlyReportApi: Http,
    private authHttp: AuthHttp
  ) {}

  // Get List Master Report Type by Year
  GetListReport(year) {
    return this.authHttp.get(environment.apiEndPoint + `/MonthlyReportType/` + year)
      .map((response: Response) => response.json());
  }

  // Get Master Report Type By ID
  GetReport(id) {
    return this.authHttp.get(environment.apiEndPoint + "/MonthlyReportType/Id/" + id)
      .map((response: Response) => response.json());
  }

  // Get Last Year List Report Year
  GetCopyReportYearDropdown(year) {
    return this.authHttp.get(environment.apiEndPoint + '/GetLastYearListReportYear/' + year)
      .map((response: Response) => response.json());
  }

  //Get List Report Year
  GetYearDropdown() {
    return this.authHttp.get(environment.apiEndPoint + '/GetListReportYear')
      .map((response: Response) => response.json())
  }

  // Get Dealer Monthly Report
  GetDealerReport(dealerId, year, month) {
    return this.authHttp.get(environment.apiEndPoint + '/MonthlyReport/GetDealerReportList/' + dealerId + '/' + year + '/' + month)
      .map((response: Response) => response.json())
  }

  // Get Dealers Report By Main Dealer ID
  GetDealersReport(mainDealerId, year, month){
    return this.authHttp.get(environment.apiEndPoint + '/MonthlyReport/GetDealersReport/' + mainDealerId + '/' + year +'/' + month)
      .map((response : Response) => response.json())
  }

  // Search Dealer Report
  SearchDealersReport(mainDealerId, year, month, status, searchDealer){
    if(!searchDealer){
        searchDealer = "";
    }
    
    var formData = new FormData();
    formData.append("mainDealerId",mainDealerId);
    formData.append("year",year);
    formData.append("month",month);
    formData.append("status",status);
    formData.append("searchDealer",searchDealer);

    return this.authHttp.post(environment.apiEndPoint + '/MonthlyReport/SearchMonthlyReport', formData)
      .map((response : Response) => response.json())
  }

  // Doenload all Dealer Monthly Report
  DownloadAllMonthlyReport(mainDealerId, year, month, status, searchDealer){
    if(!searchDealer){
      searchDealer = "";
    }
  
    var formData = new FormData();
    formData.append("mainDealerId",mainDealerId);
    formData.append("year",year);
    formData.append("month",month);
    formData.append("status",status);
    formData.append("searchDealer",searchDealer);

    return this.authHttp.post(environment.apiEndPoint + '/MonthlyReport/DownloadAll', formData, { 
      responseType: ResponseContentType.ArrayBuffer 
    })  
  }

  // Download Dealer Monthly Report
  DownloadMonthlyReport(dealerId, reportID, year, month){
    return this.authHttp.get(environment.apiEndPoint + '/MonthlyReport/Download/' + dealerId + '/' + reportID + '/' + year + '/' + month, {
      responseType : ResponseContentType.ArrayBuffer
    })
  }

  // Get Map Master Monthly Report List
  GetMapReportTypeList(year, month){
    return this.authHttp.get(environment.apiEndPoint + '/MonthlyReport/Map/' + year + '/' + month)
      .map((response : Response) => response.json())
  }
  
  // Get Map Master Monthly Report Data 
  GetMapReportTypeListByMainDealerId(mainDealerId, year, month){
    return this.authHttp.get(environment.apiEndPoint + '/MonthlyReport/Map/' + mainDealerId + '/' + year + '/' + month) 
      .map(((response : Response) => response.json()))
  }

  // Create Master MonthlyReport
  CreateMonthlyReportType(reportViewModel){
    let formData : FormData = new FormData();
    
    formData.append("Year", reportViewModel.Year);
    formData.append("ReportTypeName", reportViewModel.ReportTypeName);
    formData.append("File", reportViewModel.File);
    formData.append("IsDefault", reportViewModel.IsDefault);
    
    return this.authHttp.post(environment.apiEndPoint + '/MonthlyReportType/Create', formData)
      .map((response : Response) => response.json());
  }

  // Edit Master Monthly Report
  EditReportType(ReportViewModel){
    let formData : FormData = new FormData();
    
    formData.append("ID", ReportViewModel.ID);
    formData.append("Year", ReportViewModel.Year);
    formData.append("ReportTypeName", ReportViewModel.ReportTypeName);
    formData.append("FilePath", ReportViewModel.FilePath);
    formData.append("File", ReportViewModel.File);
    formData.append("IsDefault", ReportViewModel.IsDefault);
    formData.append("Base64TimeStatus", ReportViewModel.Base64TimeStatus);
    
    return this.authHttp.post(environment.apiEndPoint + '/MonthlyReportType/Edit', formData)
      .map((response : Response) => response.json())
  }

  // Delete Monthly Report Type
  DeleteMonthlyReportType(id, base64TimeStatus){
    return this.authHttp.delete(environment.apiEndPoint + '/MonthlyReportType/Delete/' + id + '/' + base64TimeStatus)
      .map((response : Response) => response.json())
  }

  // Edit Due Date Monthly Report Type
  EditDueDateMOnthlyReport(mapReportTypeViewModel, headers){
    return this.authHttp.post(environment.apiEndPoint + '/MonthlyReport/Map/EditDueDate', JSON.stringify(mapReportTypeViewModel), {headers : headers})
      .map((response : Response) => response.json())  
  }

  // Edit Mapping Monthly Report
  EditMapMonthlyReport(mapReportTypeViewModel, headers){
    return this.authHttp.post(environment.apiEndPoint + '/MonthlyReport/Map/EditMapReportType', JSON.stringify(mapReportTypeViewModel), { headers: headers })
      .map((response : Response) => response.json())
  }

  // Upload Monthly Report
  UploadMonthlyReport(reportViewModel){
    let formData: FormData = new FormData();
    formData.append("DealerId", reportViewModel.DealerId);
    formData.append("Year", reportViewModel.Year);
    formData.append("Month", reportViewModel.Month);
    formData.append("ReportTypeId", reportViewModel.ReportTypeId);
    formData.append("File", reportViewModel.File);
    formData.append("DealerCode", reportViewModel.DealerCode);
    formData.append("FilePath", reportViewModel.FilePath);
    formData.append("Base64TimeStatus", reportViewModel.Base64TimeStatus);

    return this.authHttp.post(environment.apiEndPoint + '/MonthlyReport/Upload', formData)
      .map((response : Response) => response.json())
  }

  // Copy Master Monthly Report
  CopyMonthlyReportType(reportCopyViewModel){
    let formData : FormData = new FormData();
    let ReportIDs : any = [];
    
    formData.append("ReportYear", reportCopyViewModel.Year);
    reportCopyViewModel.ReportViewModels.forEach(element => {
      ReportIDs.push(element.ReportID);
    });
    formData.append("ReportIDs", ReportIDs);

    return this.authHttp.post(environment.apiEndPoint + '/MonthlyReportType/CopyReport', formData)
      .map((response : Response) => response.json());
  }

  SendEmail(mainDealerID, year, month){
    var formData = new FormData();
    formData.append("year", year);
    formData.append("month", month);

    return this.authHttp.post(environment.apiEndPoint + '/MonthlyReport/Map/email/' + mainDealerID, formData).map((response: Response) => response.json());
  }

  SendEmailBlast(year, month){
    return this.authHttp.post(environment.apiEndPoint + '/MonthlyReport/Map/blastemail/' + year + '/' + month, new FormData()).map((response: Response) => response.json());
  }
}



// WEBPACK FOOTER //
// /Users/muhammadfiqihfirdiansyah/Documents/Muhammad Fiqih Firdiansyah/Project/Angular/BODES/BODES.Web.UI.Angular4/src/data/MonthlyReportApi.service.ts